import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { GlobalQuery, GlobalService } from '../../../../_core/state/global';
import { GlobalSettings } from '../../../../_core/state/global/global.model';
import { Observable, take } from 'rxjs';
import { SessionService } from '../../../../_core/state/session/session.service';
import { Router } from '@angular/router';
import { Profile, SessionQuery } from '../../../../_core/state/session';
import { MatDialog } from '@angular/material/dialog';
import { DisclaimerDialogComponent } from '../../disclaimer-dialog/disclaimer-dialog.component';

@Component({
	selector: 'app-account-bar',
	templateUrl: './account-bar.component.html',
	styleUrls: ['./account-bar.component.scss']
})
export class AccountBarComponent implements OnInit {
	public profile$: Observable<Profile>;
	public settings$: Observable<GlobalSettings>;

	public adminMode$: Observable<boolean>;
	public isSuperAdmin: boolean;
	public isGuestUser: boolean;

	@Input() user: any | {};
	@Input() showLogo = true;
	@Input() showSettings = true;
	@Input() showHelp = true;
	@Input() showLogout = true;
	@Input() lightMode = false;

	@HostBinding('class.light-mode') get lightModeClass() {
		return this.lightMode;
	}

	public hasEditorAccess: boolean = false;

	constructor(
		private readonly globalQuery: GlobalQuery,
		private readonly globalService: GlobalService,
		private readonly sessionQuery: SessionQuery,
		private readonly sessionService: SessionService,
		private readonly router: Router,
		private readonly dialog: MatDialog
	) {
		this.settings$ = this.globalQuery.select('settings');
		this.adminMode$ = this.globalQuery.select('adminMode');
		this.isSuperAdmin = this.sessionQuery.isAtLeastSuperAdmin();

		this.isGuestUser = this.sessionQuery.isGuestUser() && !this.sessionQuery.isAtLeastAdmin();
		this.profile$ = this.sessionQuery.profile$;
	}

	ngOnInit() {
		this.hasEditorAccess = this.sessionQuery.hasAdEditorPermission();
	}

	logout() {
		this.sessionService.logout();

		this.router.navigate(['']);
		this.router.navigate(['login'], {
			replaceUrl: true,
			skipLocationChange: false
		});
	}

	public showContactSupport(settings: GlobalSettings) {
		this.dialog.open(DisclaimerDialogComponent, {
			width: '600px',
			panelClass: ['background-color'],
			data: {
				title: settings.contactSupportNavItemTitle || ' ',
				message: settings.contactSupportNavItemBody || ' ',
				showClose: true,
				hideAcceptButton: true,
				htmlMessage: true
			}
		});
	}

	public syncCMS() {
		this.globalService.updateSiteConfigs().pipe(take(1)).subscribe();
	}
}
